/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/get_email_results/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdGetEmailResultsId } from "./constants";
import type { EngagementGetEmailResultsParams, EngagementGetEmailResults } from "./types";

export const getEngagementGetEmailResults = reactQueryFetcherAdapter(
  engagementAppGroupIdGetEmailResultsId,
  (
    signal: AbortSignal,
    { appGroupId, testId }: EngagementGetEmailResultsParams
  ): Promise<EngagementGetEmailResults> => {
    return fetch(
      `/engagement/${appGroupId}/get_email_results/${testId}`,
      "GET",
      {},
      { signal },
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
